import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { ReactiveFormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FieldErrorMessagesModule } from '../field-error-messages/field-error-messages.module';
import { TranslateModule } from '@ngx-translate/core';
import { AddressSelectComponent } from './address-select/address-select.component';
import { SvgIconModule } from '../svg-icon/svg-icon.module';

@NgModule({
  declarations: [AddressSelectComponent],
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
    MatTooltipModule,
    ReactiveFormsModule,
    FieldErrorMessagesModule,
    TranslateModule,
    SvgIconModule,
  ],
  exports: [AddressSelectComponent],
})
export class AddressSelectModule {}
